<template>
  <div id="app" :class="theme">
    <!-- <button @click="handleChangeTheme">换主题</button> -->
    <!-- 一级占位符 -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  created () {
    // this.$store.commit('integratePortsData', res.data)
    // this.$store.commit('magnifications', {"magnification":1})
  },
  mounted () {

  },
  data () {
    return {
      theme: 'theme_3kf_white'
    }
  },
  methods: {
  },
  computed: {},
  watch: {},
  filters: {},
  components: {}
}
</script>

<style scoped lang='less'>
</style>
